import { INavigationElement } from 'global';
import { NavigationExperimentOutput } from '../use-navigation-experiment';
import { NavigationType, TargetGroup } from '../utils';
import { PetType } from 'constants/pet-type';

type NavigationElementType = keyof typeof NavigationType;
type TargetGroupKey = keyof typeof TargetGroup;

export interface NavigationElementConfig {
  type: NavigationElementType;
  petType: PetType;
  targetGroup: TargetGroupKey;
  name: string;
}

export interface NavigationExperiments {
  [key: string]: {
    element: INavigationElement | null;
    experiment: NavigationExperimentOutput;
  };
}

export const NAVIGATION_ELEMENT_CONFIGS: NavigationElementConfig[] = [
  {
    type: 'DESKTOP',
    petType: PetType.Dog,
    targetGroup: 'NEW_CUSTOMER',
    name: 'Desktop Dog New Customer',
  },
  {
    type: 'DESKTOP',
    petType: PetType.Dog,
    targetGroup: 'EXISTING_CUSTOMER',
    name: 'Desktop Dog Existing Customer',
  },
  {
    type: 'DESKTOP',
    petType: PetType.Cat,
    targetGroup: 'NEW_CUSTOMER',
    name: 'Desktop Cat New Customer',
  },
  {
    type: 'DESKTOP',
    petType: PetType.Cat,
    targetGroup: 'EXISTING_CUSTOMER',
    name: 'Desktop Cat Existing Customer',
  },
  {
    type: 'MOBILE',
    petType: PetType.Dog,
    targetGroup: 'NEW_CUSTOMER',
    name: 'Mobile Dog New Customer',
  },
  {
    type: 'MOBILE',
    petType: PetType.Dog,
    targetGroup: 'EXISTING_CUSTOMER',
    name: 'Mobile Dog Existing Customer',
  },
  {
    type: 'MOBILE',
    petType: PetType.Cat,
    targetGroup: 'NEW_CUSTOMER',
    name: 'Mobile Cat New Customer',
  },
  {
    type: 'MOBILE',
    petType: PetType.Cat,
    targetGroup: 'EXISTING_CUSTOMER',
    name: 'Mobile Cat Existing Customer',
  },
];
